import React from 'react';
import { Box, Chip } from '@mui/material';

export default function PillFilters({ pills, value, onChange, counts = {} }) {
    return (
        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap', fontFamily: 'Poppins, sans-serif' }}>
            {pills.map((p) => {
                const active = value === p.key;
                const count = counts[p.key];
                const label = count !== undefined ? `${p.label} (${count})` : p.label;
                return (
                    <Chip
                        key={p.key}
                        label={label}
                        clickable
                        onClick={() => onChange(p.key)}
                        sx={{
                            fontWeight: 600,
                            fontSize: 12,
                            borderRadius: '20px',
                            bgcolor: active ? '#1565c0' : '#fff',
                            color: active ? '#fff' : '#666',
                            border: '1px solid',
                            borderColor: active ? '#1565c0' : '#e0e0e0',
                            ...(p.danger && !active && { borderColor: '#ef4444', color: '#c62828', bgcolor: '#fff5f5' }),
                            '&:hover': { borderColor: '#aaa' },
                        }}
                    />
                );
            })}
        </Box>
    );
}
